import React, { useRef, useState } from "react";
import { LogoutButton } from "./LogoutButton";
import { useLoaderData } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signUp } from "src/thunks/authThunk";

function SignUp() {
  const loaderdatatest = useLoaderData();
  const emailRef = useRef();
  const passwordRef = useRef();
  const usernameRef = useRef();
  const currentUser = useSelector((state) => state.auth.user);
  const signupError = useSelector((state) => state.auth.error);
  const pageStatus = useSelector((state) => state.auth.status);
  const dispatch = useDispatch();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(
      signUp({
        username: usernameRef.current.value,
        email: emailRef.current.value,
        password: passwordRef.current.value,
      })
    );
  };

  return (
    <>
      <div>
        <h2>Signup</h2>
        <h2>{loaderdatatest}</h2>
        {currentUser && (
          <>
            <p>Logged in as {currentUser.email}</p>
            <LogoutButton />
          </>
        )}
        {signupError && pageStatus=='failed' && <p>{signupError}</p>}
        {!currentUser && (
          <form onSubmit={handleSubmit}>
            <input
              type="username"
              ref={usernameRef}
              required
              placeholder="Username"
            />
            <input type="email" ref={emailRef} required placeholder="Email" />
            <input
              type="password"
              ref={passwordRef}
              required
              placeholder="Password"
            />
            <button type="submit">Sign Up</button>
          </form>
        )}
      </div>
    </>
  );
}

export default SignUp;
